import { render, staticRenderFns } from "./jcrecordZY.vue?vue&type=template&id=32fc2bd6&"
import script from "./jcrecordZY.vue?vue&type=script&lang=js&"
export * from "./jcrecordZY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports